import React from "react";

const IncomingDetails = ({ rowData }) => {
  return (
    <>
      <div className="table-responsive">
        <div className="table">
          <table>
            {/* <thead>
          <tr>
            <th>Party Name</th>
            <th>Incoming</th>
          </tr>
        </thead> */}
            <tbody>
              {rowData?.map((detail, index) => (
                <tr key={index}>
                  <td style={{ lineHeight: "0", padding: "0px" }}>
                    {detail.party_name} :{" "}
                  </td>
                  <td style={{ lineHeight: "0" }}>{detail.incoming}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default IncomingDetails;
